// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-cart-profile_login',
    emits: ['loggedin'],
    // #endregion
    // #region Properties
    props: {
        mode: {
            type: String,
            required: false,
            default: 'login'
        },
        data: {
            type: Object,
            required: false,
            default: {}
        },
    },
    data: () => ({
        userID: "",
        userName: "",
        password: "",
        errorMessage: "",
        internalMode: "login",
        isLoading: false,
        code: "",
        codeConfirmed: "",
    }),
    // #endregion
    // #region Constructor
    created() {
        //User
        this.userName = host.login.getUsername() ?? '';
    },
    beforeMount() {
        //Bus
        this.$host.eventBus.on('checkout-before-commit', this.OnCartNext);
        //Run
        if (!utils.isNullOrEmpty(this.mode)) {
            this.internalMode = this.mode;
        }
    },
    beforeUnmount() {
        this.$host.eventBus.off('checkout-before-commit', this.OnCartNext);
    },
    // #endregion
    // #region Computed
    computed: {
        hasError() {
            return !utils.isEmpty(this.errorMessage);
        },
        disableLogin() {
            return utils.isEmpty(this.userName) || utils.isEmpty(this.password);
        },
        disableRecovery() {
            return utils.isEmpty(this.userName);
        },
        disableActivation() {
            return utils.isNullOrEmpty(this.codeConfirmed) || this.code !== this.codeConfirmed;
        }
    },
    // #endregion
    // #region Watch
    watch: {
        userName: function (val) {
            this.errorMessage = '';
        },
        password: function (val) {
            this.errorMessage = '';
        },
        mode: function (val) {
            if (!utils.isNullOrEmpty(val)) {
                this.internalMode = val;
            }
        },
        internalMode: function (val) {
            //Message
            this.errorMessage = '';
            //Special
            if (val === 'activate' || val === 'activate-inline') {
                this.sendActivation();
            }
        }
    },
    // #endregion
    // #region Core
    methods: {
        runLogin() {
            // #region Check
            //Reset
            this.errorMessage = "";
            if (this.isLoading) {
                return;
            }
            //Check
            if (utils.isEmpty(this.userName)) {
                return;
            }
            if (utils.isEmpty(this.password)) {
                return;
            }
            // #endregion
            // #region Meter
            this.isLoading = true;
            // #endregion
            // #region Run
            host.login.loginByUsername(this.userName, this.password).then((e) => {
                // #region Meter
                this.isLoading = false;
                // #endregion
                // #region Notify
                if (!e.isSucceded && e.errorCode === "account_activate") {
                    this.userID = e.customData.userid;
                    this.internalMode = 'activate';
                }
                else if (e.isSucceded) {
                    this.$emit('loggedin');
                }
                else {
                    this.errorMessage = e.errorMessage;
                }
                // #endregion
            })
                .catch((e) => {
                // #region Meter
                this.isLoading = false;
                // #endregion
                // #region Set
                this.errorMessage = utils.getAxiosErrorMessage(e);
                // #endregion
            });
            // #endregion
        },
        runRecovery() {
            // #region Check
            if (this.isLoading) {
                return;
            }
            if (utils.isNullOrEmpty(this.userName)) {
                return;
            }
            // #endregion
            // #region Meter
            this.isLoading = true;
            // #endregion
            // #region Run
            host.api.post('identity/profile/password-recovery', null, { params: { address: this.userName } })
                .then((e) => {
                // #region Meter
                this.isLoading = false;
                // #endregion
                // #region Set
                this.internalMode = 'recovery-sent';
                // #endregion
            })
                .catch((e) => {
                // #region Meter
                this.isLoading = false;
                // #endregion
                // #region Set
                this.errorMessage = utils.getAxiosErrorMessage(e);
                // #endregion
            });
            // #endregion
        },
        sendActivation() {
            // #region Check
            if (this.isLoading) {
                return;
            }
            // #endregion
            // #region Send
            let config = {
                params: {
                    userId: this.data?.userID
                },
            };
            host.api.get("identity/profile/activate", config)
                .then((e) => {
                // #region Set
                this.userID = e.data.userid;
                this.code = e.data.token;
                // #endregion
            })
                .catch((e) => {
                // #region Set
                this.errorMessage = utils.getAxiosErrorMessage(e);
                // #endregion
            });
            // #endregion
        },
        runActivate() {
            // #region Run
            this.executeActivate(false);
            // #endregion
        },
        async executeActivate(isInline) {
            // #region Check
            if (this.isLoading) {
                return false;
            }
            if (utils.isNullOrEmpty(this.codeConfirmed)) {
                return false;
            }
            if (this.codeConfirmed != this.code) {
                return false;
            }
            // #endregion
            // #region Meter
            this.isLoading = true;
            // #endregion
            // #region Activate
            let tData = {
                userId: this.userID,
                code: this.code,
                codeConfirmed: this.codeConfirmed
            };
            return host.login.activate(tData)
                .then(e => {
                // #region Meter
                this.isLoading = false;
                // #endregion
                // #region Run
                if (e.isSucceded) {
                    if (!isInline) {
                        this.$emit('loggedin');
                    }
                }
                else {
                    this.errorMessage = e.errorMessage;
                }
                // #endregion
                return e.isSucceded;
            })
                .catch((e) => {
                // #region Meter
                this.isLoading = false;
                // #endregion
                // #region Set
                this.errorMessage = utils.getAxiosErrorMessage(e);
                // #endregion
                return false;
            });
            // #endregion
        },
        async OnCartNext(args) {
            // #region activate-inline
            if (this.internalMode == 'activate-inline') {
                if (!await this.executeActivate(true)) {
                    args.cancel = true || args.cancel;
                }
            }
            else {
                args.cancel = true;
            }
            // #endregion                
        }
    }
    // #endregion
});
// #endregion
